import React from "react";
import { Grid, Paper, Typography, Box } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import DyanmicTable from "../../../components/DyanmicTable";

const UpsellCrossSellDetailPaper = ({
  classes,
  paperTitle,
  currencySymbol,
  upsellCrossSellData,
  Value_Label,
  handleChangeLocation,
}) => {
  if (!upsellCrossSellData || upsellCrossSellData === "") {
    return (
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Box display="flex" flexDirection="column" alignItems="center" mb={3}>
            <Typography variant="h5" className={classes.title}>
              {paperTitle || "Upsell / Cross-Sell Qualified Pipeline"}
            </Typography>
          </Box>
          <Skeleton variant="rect" animation="wave" height={400} width="100%" style={{ margin: "1rem auto" }} />
        </Paper>
      </Grid>
    );
  }

  const custTypeItem = upsellCrossSellData?.pipelineMixByCustType;

  if (!custTypeItem) return null;

  return (
    <Grid item xs={12}>
      <Paper className={classes.paper}>
        <Box display="flex" flexDirection="column" alignItems="center" mb={3}>
          <Typography variant="h5" className={classes.title}>
            {paperTitle || "Upsell / Cross-Sell Qualified Pipeline"}
          </Typography>
          <span className={classes.updateFrequency}>{"Live Data"}</span>
        </Box>
        <DyanmicTable
          type={custTypeItem.type}
          quarter={custTypeItem.timeline}
          winAcvData={custTypeItem.data}
          clusterTotal={[]}
          handleChangeLocation={handleChangeLocation}
          sortByTotal={true}
          label={custTypeItem.label}
          sotedStages={[]}
          toggleValue="acv"
          Value_Label={`ACV (${currencySymbol}K)`}
          UICols={custTypeItem.UICols}
          formatInThousands={true}
        />
      </Paper>
    </Grid>
  );
};

export default UpsellCrossSellDetailPaper;
